import { useState } from "react";
import { api } from "../lib/api";
import sangriaMark from "../assets/sangria-studio-mark.png";

// Small inline Google mark — avoids pulling a full icon library.
const GoogleIcon = (
  <svg width="16" height="16" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.64 9.2c0-.64-.06-1.25-.17-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.71v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.61z" fill="#4285F4"/>
    <path d="M9 18c2.43 0 4.47-.81 5.96-2.19l-2.92-2.26c-.81.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.71H.96v2.33A8.997 8.997 0 0 0 9 18z" fill="#34A853"/>
    <path d="M3.97 10.7A5.41 5.41 0 0 1 3.68 9c0-.59.1-1.16.29-1.7V4.97H.96A8.997 8.997 0 0 0 0 9c0 1.45.35 2.83.96 4.03l3.01-2.33z" fill="#FBBC05"/>
    <path d="M9 3.58c1.32 0 2.51.45 3.44 1.35l2.58-2.58C13.46.89 11.43 0 9 0A8.997 8.997 0 0 0 .96 4.97l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z" fill="#EA4335"/>
  </svg>
);

export default function Login({ onLogin, onBack }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const r = await api.login(username, password, rememberMe);
      onLogin(r.user);
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Sign in failed");
    } finally {
      setBusy(false);
    }
  };

  const signInWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
    // THIS BREAKS THE AUTH.
    const redirectUrl = window.location.origin + "/auth-callback";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };

  return (
    <div className="login-wrap">
      {onBack && (
        <button
          type="button"
          className="login-back"
          onClick={onBack}
          data-testid="login-back-to-portal"
          aria-label="Back to portal"
        >
          ← Back to portal
        </button>
      )}
      <form className="login-card login-card-centered" onSubmit={submit} data-testid="login-form">
        <div className="login-head">
          <div className="login-logo" aria-hidden>
            <img
              src={sangriaMark}
              alt=""
              width="48"
              height="48"
              className="login-logo__img"
            />
          </div>
          <h1 className="login-title">Sangria Studio</h1>
        </div>

        {/*  ── User ID + password (primary flow) ─────────────────────────  */}
        <div className="form-field">
          <label htmlFor="u">User ID</label>
          <input
            id="u" data-testid="login-username"
            value={username} onChange={(e) => setUsername(e.target.value)}
            autoComplete="username" spellCheck={false} autoFocus
          />
        </div>
        <div className="form-field">
          <label htmlFor="p">Password</label>
          <input
            id="p" data-testid="login-password" type="password"
            value={password} onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </div>
        <button
          className="btn-primary" type="submit"
          data-testid="login-submit"
          disabled={busy || !username || !password}
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
        <label className="login-remember" data-testid="login-remember-label">
          <input
            type="checkbox"
            data-testid="login-remember"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
          />
          <span>Remember me for 30 days</span>
        </label>
        {err && <div className="form-error" data-testid="login-error">{err}</div>}

        {/*  ── Google sign-in (surfaced up-front — no More options step) ──  */}
        <div className="oauth-divider"><span>or</span></div>
        <button
          type="button"
          className="oauth-btn"
          onClick={signInWithGoogle}
          disabled={busy}
          data-testid="oauth-google"
          title="Sign in with Google"
        >
          <span className="oauth-ico" aria-hidden>{GoogleIcon}</span>
          <span>Continue with Google</span>
        </button>
      </form>
    </div>
  );
}
